export const BANK_ATTACHMENT_TYPES = {
  BANK_BUSINESS_REGISTRATION: 'BANK_BUSINESS_REGISTRATION',
  BANK_GBR_CONTRACT: 'BANK_GBR_CONTRACT',
  BANK_SELF_DISCLOSURE: 'BANK_SELF_DISCLOSURE',
  BANK_INCOME_TAX_ASSESSMENT: 'BANK_INCOME_TAX_ASSESSMENT',
  BANK_INCOME_TAX_RETURN: 'BANK_INCOME_TAX_RETURN',
  BANK_DECEMBER_PAYSLIP: 'BANK_DECEMBER_PAYSLIP',
  BANK_CURRENT_PAYSLIP: 'BANK_CURRENT_PAYSLIP',
  BANK_ANNUAL_FINANCIAL_STATEMENT: 'BANK_ANNUAL_FINANCIAL_STATEMENT',
  BANK_BWA_SUSA_FULL_YEAR: 'BANK_BWA_SUSA_FULL_YEAR',
  BANK_CURRENT_BWA: 'BANK_CURRENT_BWA',
  BANK_RENTAL_INCOME_STATEMENTS: 'BANK_RENTAL_INCOME_STATEMENTS',
  BANK_GIRO_ACCOUNT_STATEMENT: 'BANK_GIRO_ACCOUNT_STATEMENT',
  BANK_SAVINGS_ACCOUNT_STATEMENT: 'BANK_SAVINGS_ACCOUNT_STATEMENT',
  BANK_SECURITIES_DEPOT_STATEMENT: 'BANK_SECURITIES_DEPOT_STATEMENT',
  BANK_LIABILITIES_OVERVIEW: 'BANK_LIABILITIES_OVERVIEW',
  BANK_OVERDRAFT_STATEMENT: 'BANK_OVERDRAFT_STATEMENT',
  BANK_CONSUMER_LOAN_STATEMENT: 'BANK_CONSUMER_LOAN_STATEMENT',
  BANK_REAL_ESTATE_LOAN_STATEMENT: 'BANK_REAL_ESTATE_LOAN_STATEMENT',
};

/** Generated bank artifacts stored in bank.attachments (not user-uploadable). */
export const BANK_GENERATED_ATTACHMENT_TYPES = {
  BANK_ATTACHMENTS_ZIP: 'BANK_ATTACHMENTS_ZIP',
};

/** Static Selbstauskunft template served from public/. */
export const BANK_SELF_DISCLOSURE_TEMPLATE_PATH = '/documents/selbstauskunft.xlsx';

export const GBR_STATUS = {
  FOUNDED: 'FOUNDED',
  TO_BE_FOUNDED: 'TO_BE_FOUNDED',
  NONE: 'NONE',
};
